/**
 * The icon keys the brand ships. GENERATED by scripts/sync-design-system.ts.
 *
 * A category's `icon_key` is validated by the API as a string of up to sixty
 * characters, so a name that draws nothing passes. This is the actual list, so
 * `IconPicker` can only offer an icon that exists.
 */
export const ICON_KEYS = [
  'bell',
  'bookmark',
  'bookmark-fill',
  'briefcase',
  'calendar',
  'camera',
  'card',
  'check',
  'check-circle',
  'chevron-left',
  'chevron-right',
  'clock',
  'close',
  'download',
  'external',
  'eye',
  'eye-off',
  'file',
  'globe',
  'history',
  'info',
  'journal',
  'leave',
  'location',
  'lock',
  'logo-mark',
  'mic',
  'mic-off',
  'minus',
  'offline',
  'people',
  'plus',
  'pulse',
  'search',
  'shield-check',
  'star',
  'tab-book',
  'tab-book-fill',
  'tab-events',
  'tab-events-fill',
  'tab-home',
  'tab-home-fill',
  'tab-hours',
  'tab-hours-fill',
  'tab-learn',
  'tab-learn-fill',
  'tab-listing',
  'tab-listing-fill',
  'tab-profile',
  'tab-wellness',
  'tab-wellness-fill',
  'ticket',
  'trash',
  'video',
  'vitals',
  'warning',
  'weight',
  'wellness-food',
  'wellness-mood',
  'wellness-sleep',
  'wellness-water',
  'wellness-water-solid',
] as const

export type IconKey = (typeof ICON_KEYS)[number]

/**
 * The ones worth offering as a category's icon.
 *
 * The brand mark, the phone's bottom-tab icons and their selected twins, and
 * the interface verbs are left out — see `NOT_A_CATEGORY` in the generator
 * for why each kind goes. A category wearing the product's own logo, or a
 * close cross, is a category nobody chose to look like that.
 */
export const CATEGORY_ICON_KEYS = [
  'bookmark',
  'briefcase',
  'calendar',
  'camera',
  'card',
  'clock',
  'file',
  'globe',
  'journal',
  'location',
  'mic',
  'people',
  'pulse',
  'shield-check',
  'star',
  'ticket',
  'video',
  'vitals',
  'weight',
  'wellness-food',
  'wellness-mood',
  'wellness-sleep',
  'wellness-water',
] as const
